// extracted by mini-css-extract-plugin
module.exports = {"nameLine":"styles_nameLine__3zc2g"};